import { siteInfo } from '@/mocks/home';

const footerLinks = [
  {
    title: '快速导航',
    links: [
      { label: '热门专题', href: '#carousel' },
      { label: '精选推荐', href: '#cards' },
      { label: '平台特色', href: '#features' },
      { label: '漫画分类', href: '#index' },
    ],
  },
  {
    title: '帮助中心',
    links: [
      { label: '常见问题', href: '#faq' },
      { label: '联系我们', href: '#contact' },
      { label: '阅读指南', href: '#features' },
      { label: '更新动态', href: '#updates' },
    ],
  },
];

export default function Footer() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-950">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-[1280px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10 mb-10">
            <div className="lg:col-span-2">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-ancient-gate-line text-background-50 text-base"></i>
                </div>
                <span className="font-heading text-lg font-bold text-background-50">
                  {siteInfo.name}
                </span>
              </div>
              <p className="text-sm text-background-400 leading-relaxed max-w-[400px] mb-4">
                樱花动漫91是国内领先的在线漫画阅读平台，采用创新的下拉式阅读模式，提供海量正版高清漫画资源。涵盖热血、恋爱、悬疑、搞笑、科幻、奇幻等多种题材，每日更新最新漫画章节，让漫画爱好者随时随地免费阅读好看的漫画。
              </p>
            </div>

            {footerLinks.map((group) => (
              <div key={group.title}>
                <h3 className="font-semibold text-sm text-background-200 mb-4">{group.title}</h3>
                <ul className="flex flex-col gap-2.5">
                  {group.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        onClick={(e) => { e.preventDefault(); handleScroll(link.href); }}
                        className="text-sm text-background-500 hover:text-background-200 transition-colors cursor-pointer"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="border-t border-background-800 pt-8">
            <div className="mb-8">
              <h3 className="font-semibold text-sm text-background-300 mb-4">合作伙伴</h3>
              <p className="text-sm text-background-600">诚邀各大漫画平台、内容创作者、动漫周边品牌洽谈合作</p>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-background-600">
                &copy; {new Date().getFullYear()} {siteInfo.name}. 本站所有漫画内容仅供学习交流，版权归原作者所有。
              </p>
              <div className="flex items-center gap-4">
                <span className="text-xs text-background-600 whitespace-nowrap">下拉式阅读 · 沉浸式追漫</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}